var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.5 0C22.288 0 27 4.71 27 10.5v9h2.258A3.746 3.746 0 0 1 33 23.242v21.006A3.756 3.756 0 0 1 29.248 48H3.75A3.756 3.756 0 0 1 0 44.248V23.244A3.746 3.746 0 0 1 3.743 19.5H6v-9C6 4.71 10.71 0 16.5 0zm12.758 22.5H3.742a.743.743 0 0 0-.743.742v21.006c0 .415.337.752.75.752h25.498a.753.753 0 0 0 .752-.752V23.244a.743.743 0 0 0-.742-.743zm-12.758 6c.828 0 1.5.67 1.5 1.5v7.5a1.5 1.5 0 1 1-3 0V30c0-.83.672-1.5 1.5-1.5zm0-25.5C12.364 3 9 6.364 9 10.5v9h15v-9C24 6.364 20.636 3 16.5 3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E67670",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9 0h48v48H-9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.dbe97a35d4fbe1c6813132a974d90d47.svg";
export { ForwardRef as ReactComponent };